var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"w-full border border-gray-100 rounded-lg",attrs:{"disabled":_vm.disabled,"inline":_vm.inline,"placeholder":_vm.placeholder,"autocomplete":"off"},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }